import { getUserIdsForTeamId } from "@coworker/app/src/hooks/API/core.service";

export const getRelevantUsersIds = async (
  uid: string,
  teamIdOrUserId: string | undefined
) => {
  if (!teamIdOrUserId) {
    return "";
  }

  if (uid === teamIdOrUserId) {
    return uid;
  } else {
    const teamsUserIds = await getUserIdsForTeamId(teamIdOrUserId);
    if (teamsUserIds.data.length === 0) {
      return "emptyTeam";
    } else {
      return teamsUserIds.data
        .map((user: { uid: string }) => user.uid)
        .join(",");
    }
  }
};
